import type { TFunction } from 'i18next';

/**
 * Task Status enum values
 */
const TASK_STATUS_VALUES = {
  PENDING: 'Pending',
  IN_PROGRESS: 'InProgress',
  DELAYED: 'Delayed',
  COMPLETED: 'Completed',
  ARCHIVED: 'Archived',
} as const;

/**
 * Task Priority enum values
 */
const TASK_PRIORITY_VALUES = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  URGENT: 'Urgent',
} as const;

/**
 * Translate task status enum value to localized string
 *
 * @param value - The status enum value
 * @param t - Translation function from i18next
 * @returns Translated status string or original value if not found
 */
export const translateStatus = (value: string, t: TFunction): string => {
  switch (value) {
    case TASK_STATUS_VALUES.PENDING:
      return t('common.pending');
    case TASK_STATUS_VALUES.IN_PROGRESS:
      return t('common.inProgress');
    case TASK_STATUS_VALUES.DELAYED:
      return t('common.delayed');
    case TASK_STATUS_VALUES.COMPLETED:
      return t('common.completed');
    case TASK_STATUS_VALUES.ARCHIVED:
      return t('taskStatus.archived');
    default:
      return value;
  }
};

/**
 * Translate task priority enum value to localized string
 *
 * @param value - The priority enum value
 * @param t - Translation function from i18next
 * @returns Translated priority string or original value if not found
 */
export const translatePriority = (value: string, t: TFunction): string => {
  switch (value) {
    case TASK_PRIORITY_VALUES.LOW:
      return t('common.low');
    case TASK_PRIORITY_VALUES.MEDIUM:
      return t('common.medium');
    case TASK_PRIORITY_VALUES.HIGH:
      return t('common.high');
    case TASK_PRIORITY_VALUES.URGENT:
      return t('common.urgent');
    default:
      return value;
  }
};
